// The company Instagram (renamed from @requesta.app in October 2026, then from
// @request.dj on 2026-11-01).
export const INSTAGRAM_HANDLE = "request_app_official";
export const INSTAGRAM_URL = `https://instagram.com/${INSTAGRAM_HANDLE}`;

export interface PressArticle {
  publication: string;
  url: string;
  headline: string;
  excerpt: string;
  image: string;
}

export const PRESS_ARTICLES: PressArticle[] = [
  {
    publication: "The Influential",
    url: "https://www.the-influential.com/2026/03/request-app-live-entertainment-fan-song-request-platform.html",
    headline: "The Global Platform Defining The New Income Layer for Live Entertainers",
    excerpt:
      "Request.app enables live entertainers — DJs, bands, musicians, performers — to receive structured input and monetized requests, building reliable income from audience and brand interactions.",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEixlbFsrJHKdftscQufPQZc1TDxyTkaem0Txlg5ejQ7ax9m7PLa8fV2iO-9gdFiqxjOqaPGPDAa1xX7ttjXmCxGGYVHGt2Bshc35xydihfZ12Iq5hK29-Qof1kktJgLvYSFj9sKB8EKwn7GbKBlpHQWQr_C2yeIML6VGgzRI-SinHTMjoIlR3gehYfwneUV/s1600/TheInfluential-Request-app-1.jpg",
  },
  {
    publication: "Beverly Weekly",
    url: "https://www.beverlyweekly.com/2026/03/request-app-live-event-monetization-platform.html",
    headline: "How Request.app Is Modernizing the Business of Live Entertainment",
    excerpt:
      "Request.app helps performers monetize fan requests, brand promotions, and live audience engagement worldwide.",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg4RFAnXnmUhG9wVNAtj3KCJUBpqaYqfV5nEbvei4CUafRvq6-OaJo4D38R7P2-txN2upwIrL5bEWUpFp9zEBeUEip6jMCqQJVbXLjhyxh9urAUN_5HeuyxSZCD2_weKyYWD_UHLPPaEGG6g1aacKqwgRkeAew8Zdg-Ycwwi3TA3jPq06NlcSIegjHzLMg/s1600/TheBeverlyWeekly-Request-App-1.jpg",
  },
  {
    publication: "CelebrityNews",
    url: "https://celebritynews.com/request-app-wants-to-be-the-new-income-layer-for-live-entertainment/",
    headline: "Request.app Wants to Be the New Income Layer for Live Entertainment",
    excerpt:
      "Request.app aims to modernize song requests and audience engagement for live performers globally — a unified monetization system for DJs, bands, musicians, and entertainers across venues.",
    image:
      "https://celebritynews.com/wp-content/uploads/elementor/thumbs/image1-5-rkeq6krab5su66hdjjn6i11lhysg59odnsahp8z5o0.jpg",
  },
];
